import { render } from "./StopSend.vue?vue&type=template&id=281d473c&scoped=true&ts=true"
import script from "./StopSend.vue?vue&type=script&lang=ts"
export * from "./StopSend.vue?vue&type=script&lang=ts"

import "./StopSend.vue?vue&type=style&index=0&id=281d473c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2791644585/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281d473c"]])

export default __exports__